import {
  useWindowWidth,
} from '@react-hook/window-size'

export const UseWidth = ( ) => {
  const width = useWindowWidth();
  return width;
}
